import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var MultipleChoiceSvg = function MultipleChoiceSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 10.547a8.547 8.547 0 1 1 17.094 0H17.7a7.152 7.152 0 1 0-7.152 7.152v1.395A8.547 8.547 0 0 1 2 10.547"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.489 10.547a5.059 5.059 0 0 1 10.117 0H14.21a3.663 3.663 0 1 0-3.663 3.663v1.396a5.06 5.06 0 0 1-5.058-5.059"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m21.981 13.619-10.593-2.23 2.23 10.592 2.598-2.597L18.833 22 22 18.833l-2.616-2.617zm-7.528 5.554-1.258-5.978 5.978 1.258-1.763 1.763 2.616 2.617-1.193 1.194-2.617-2.617z",
    clipRule: "evenodd"
  }));
};
export var MultipleChoice = function MultipleChoice(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: MultipleChoiceSvg
  }));
};